import React from "react";
import { motion } from "framer-motion";
import Section from "./Section";

const problems = [
  {
    n: "01",
    title: "Fragmented hotel systems",
    body: "PMS, POS, door locks, IPTV — teams juggle 15–20 disparate tools with no single source of truth.",
  },
  {
    n: "02",
    title: "Language barriers",
    body: "Global travellers speak 100+ languages at your front desk — service breaks the moment translation fails.",
  },
  {
    n: "03",
    title: "Manual operations",
    body: "Paper checklists and radio calls slow every request and make performance impossible to measure.",
  },
  {
    n: "04",
    title: "Slow guest service",
    body: "A 5-minute request turns into a 45-minute delay. That's the difference between a review and a refund.",
  },
  {
    n: "05",
    title: "Staff coordination",
    body: "Departments work in silos. Escalations vanish. VIP moments get missed at exactly the wrong time.",
  },
  {
    n: "06",
    title: "No operational visibility",
    body: "GMs run properties on gut-feel. SLA breaches only surface after the guest is already gone.",
  },
];

export default function Problem() {
  return (
    <Section
      id="problem"
      overline="The problem"
      testId="problem-section"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-end">
        <div className="md:col-span-7">
          <h2
            className="font-display text-white text-[36px] md:text-[56px] leading-[1.02] tracking-tight"
            style={{ fontWeight: 800 }}
          >
            Hotels have never been more complex.{" "}
            <span className="text-white/50">Their tools haven&apos;t caught up.</span>
          </h2>
        </div>
        <div className="md:col-span-5 md:pl-8">
          <p className="text-white/75 text-[16px] leading-relaxed">
            Six challenges every operator recognises — and iNPLASS is built to
            resolve, in a single connected platform.
          </p>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {problems.map((p, i) => (
          <motion.article
            key={p.n}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, delay: i * 0.05 }}
            className="group relative rounded-xl brand-panel p-7 hover:border-brand-purpleLight/60 hover:-translate-y-1 transition-transform duration-300"
            data-testid={`problem-card-${i + 1}`}
          >
            <div className="flex items-center justify-between">
              <span className="font-display text-[14px] tracking-[0.24em] text-brand-orange font-bold">
                {p.n}
              </span>
              <span className="w-8 h-px bg-white/20 group-hover:bg-brand-orange/70 transition-colors" />
            </div>
            <h3
              className="mt-5 font-display text-white text-[22px] leading-tight"
              style={{ fontWeight: 700 }}
            >
              {p.title}
            </h3>
            <p className="mt-3 text-white/75 text-[14px] leading-relaxed">
              {p.body}
            </p>
          </motion.article>
        ))}
      </div>
    </Section>
  );
}
